var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isValidStatusToSubmitDocumentation || _vm.sucessSubmitFile
        ? _c("finished-documentation")
        : _c(
            "div",
            { staticClass: "w-full flex justify-center" },
            [
              _c(
                "jade-page-container",
                {
                  attrs: { size: "wide" },
                  scopedSlots: _vm._u([
                    {
                      key: "aside",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-6" },
                            [
                              _c("representment-resume"),
                              _vm.totalSizeError
                                ? _c(
                                    "jade-alert",
                                    {
                                      attrs: {
                                        variant: "negative",
                                        showIcon: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("total.size.error")) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "jade-button",
                                {
                                  attrs: {
                                    variant: "primary-solid",
                                    loading: _vm.submitFileIsLoading,
                                    disabled: _vm.sendDocumentationIsDisabled,
                                  },
                                  on: { click: _vm.submitFile },
                                },
                                [_vm._v(_vm._s(_vm.$t("send.documentation")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("jade-box", { staticClass: "lg:flex-[2]" }, [
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-3 p-5" },
                      [
                        _c(
                          "jade-text",
                          {
                            attrs: { variant: "heading-xsmall", color: "high" },
                          },
                          [_vm._v(_vm._s(_vm.$t("send.document")))]
                        ),
                        _c(
                          "jade-text",
                          { attrs: { color: "medium", weight: "medium" } },
                          [
                            _vm._v(_vm._s(_vm.$t("paragraph.1")) + " "),
                            _c(
                              "span",
                              { staticClass: "text-jade-content-high" },
                              [_vm._v(_vm._s(_vm.$t("paragraph.2")))]
                            ),
                          ]
                        ),
                        _c(
                          "jade-link",
                          {
                            attrs: {
                              external: "",
                              href: _vm.$sanitize(
                                _vm.chargebackDocumentationUrl
                              ),
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("documents-list.link")))]
                        ),
                        _c("file-drag-and-drop", {
                          attrs: { files: _vm.files, limit: 50 },
                          on: {
                            "update:files": function ($event) {
                              _vm.files = $event
                            },
                          },
                        }),
                        _vm._l(_vm.filesItems, function (fileItem, index) {
                          return _c("file-list-item", {
                            key: `${fileItem.name}-${index}`,
                            attrs: {
                              file: fileItem,
                              fileIsLoading: _vm.filesIsLoading,
                            },
                            on: { deleteFile: _vm.deleteFile },
                          })
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }